<div fxFlex="0 0 100%" fxLayout="column" fxLayoutAlign="start center">
    <app-sticky-header
        class="sticky-header"
        [title]="data.resource.title"
        [context]="AppScope.label(data.resource.scope_id, false)"
        contextIcon="edit"
        customBtn="Edit Source"
        i18n-customBtn="@@editSource"
        (onSubmit)="done()"
        (onCancel)="onCancel()"
        (onCustomBtn)="editSource = true; done()"
        savingTitle="Save"
        i18n-savingTitle="@@save"
        [savingStatus]="saving | async"
    ></app-sticky-header>
    <div class="w-100" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
        <ng-container [ngSwitch]="data.resource.scope_id">
            <ng-container *ngSwitchCase="AppScope.MATERIAL">
                <app-course-manager-core-material-manager
                    class="w-100 p-1"
                    (saved)="onSubmit($event.res)"
                    [resource]="data.resource"
                    [opened]="data.openedMaterialItemIndex"
                    [isEditInBottomSheet]="true"
                    #compRef
                >
                </app-course-manager-core-material-manager>
            </ng-container>
            <ng-container *ngSwitchCase="AppScope.TEST">
                <app-course-manager-create-test
                    #compRef
                    class="w-100 p-1 test-create-bottom-sheet"
                    [resource]="data.resource"
                    [isEditInBottomSheet]="true"
                    (published)="onSubmit($event.res)"
                    (onError)="onError()"
                ></app-course-manager-create-test>
            </ng-container>
            <ng-container *ngSwitchCase="AppScope.SURVEY">
                <app-course-manager-create-survey
                    #compRef
                    [resource]="data.resource"
                    [isEditInBottomSheet]="true"
                    class="w-100 p-1 survey-create-bottom-sheet"
                    (published)="onSubmit($event.res)"
                    (onError)="onError()"
                ></app-course-manager-create-survey>
            </ng-container>
            <ng-container *ngSwitchCase="AppScope.EVENT">
                <app-course-manager-event-create
                    #compRef
                    class="w-100 p-1"
                    [isEditInBottomSheet]="true"
                    [resource]="data.resource"
                    (saved)="onSubmit($event.res)"
                ></app-course-manager-event-create>
            </ng-container>
            <ng-container *ngSwitchCase="AppScope.SCORM">
                <app-course-manager-create-scorm
                    #compRef
                    class="w-100 p-1"
                    [isEditInBottomSheet]="true"
                    [resource]="data.resource"
                    (published)="onSubmit($event.res)"
                ></app-course-manager-create-scorm>
            </ng-container>
        </ng-container>
    </div>
</div>
